const IconLib = {
  basilVideoOutline:
    require("../assets/ClikkleFilesIcons/basil_video-outline.svg").default,
  bytesizeBell: require("../assets/ClikkleFilesIcons/bytesize_bell.svg")
    .default,
  feAppMenu: require("../assets/ClikkleFilesIcons/fe_app-menu.svg").default,
  fluentGrid28Regular:
    require("../assets/ClikkleFilesIcons/fluent_grid-28-regular.svg").default,
  fluentGrid28Regularblack:
    require("../assets/ClikkleFilesIcons/fluent_grid-28-regularblack.png")
      .default,
  fluentGrid28Regularblue:
    require("../assets/ClikkleFilesIcons/fluent_grid-28-regularblue.svg")
      .default,
  fluentPeople16Regular:
    require("../assets/ClikkleFilesIcons/fluent_people-16-regular.svg").default,
  fluentPerson24Regular:
    require("../assets/ClikkleFilesIcons/fluent_person-24-regular.svg").default,
  ggSearch: require("../assets/ClikkleFilesIcons/gg_search.svg").default,
  addButton: require("../assets/ClikkleFilesIcons/addButton.svg").default,
  iconParkOutlineMessage:
    require("../assets/ClikkleFilesIcons/icon-park-outline_message.svg")
      .default,
  iconamoonClockLight:
    require("../assets/ClikkleFilesIcons/iconamoon_clock-light.svg").default,
  icOutlineFolder: require("../assets/ClikkleFilesIcons/ic_outline-folder.svg")
    .default,
  icOutlineFolderlm:
    require("../assets/ClikkleFilesIcons/ic_outline-folder.svg").default,
  mdiLightSettings:
    require("../assets/ClikkleFilesIcons/mdi-light_settings.svg").default,
  mdiHomeOutline: require("../assets/ClikkleFilesIcons/mdi_home-outline.svg")
    .default,
  mdiStarOutline: require("../assets/ClikkleFilesIcons/mdi_star-outline.svg")
    .default,
  octiconTrash24: require("../assets/ClikkleFilesIcons/octicon_trash-24.svg")
    .default,
  listlm: require("../assets/ClikkleFilesIcons/listlm.svg").default,
  listblue: require("../assets/ClikkleFilesIcons/listblue.svg").default,

  basilVideoOutlinelm: require("../assets/ClikkleFilesIcons/basil_video-outlinelm.png"),
  bytesizeBelllm: require("../assets/ClikkleFilesIcons/bytesize_belllm.png"),
  feAppMenulm: require("../assets/ClikkleFilesIcons/fe_app-menulm.png"),
  ggSearchlm: require("../assets/ClikkleFilesIcons/gg_searchlm.png"),
  iconParkOutlineMessagelm: require("../assets/ClikkleFilesIcons/icon-park-outline_messagelm.png"),
  iconamoonClockLightlm: require("../assets/ClikkleFilesIcons/iconamoon_clock-lightlm.png"),
  mdiLightSettingslm: require("../assets/ClikkleFilesIcons/mdi-light_settingslm.png"),
  mdiHomeOutlinelm: require("../assets/ClikkleFilesIcons/mdi_home-outlinelm.png"),
  mdiStarOutlinelm: require("../assets/ClikkleFilesIcons/mdi_star-outlinelm.png"),
  octiconTrash24lm: require("../assets/ClikkleFilesIcons/octicon_trash-24lm.png"),
  dashboard: require("../assets/ClikkleFilesIcons/Dashboard (1).png"),
  subscription: require("../assets/ClikkleFilesIcons/subscription.png"),
  users: require("../assets/ClikkleFilesIcons/user.png"),
  location: require("../assets/ClikkleFilesIcons/location (1).png"),  
  ipaddress: require("../assets/ClikkleFilesIcons/ipaddress.png"),
  transaction: require("../assets/ClikkleFilesIcons/icon-park-outline_transaction-order.png"),
  storage: require("../assets/ClikkleFilesIcons/storage.png"),
  Products: require("../assets/ClikkleFilesIcons/products.png"),
  loginactivity: require("../assets/ClikkleFilesIcons/fluent_people-16-regular.png"),
};

export default IconLib;
